/**
 * MultiViewGroupPosition constants
 * @public
 */
export const MultiViewGroupPositions = {
    right: "right",
    left: "left"
};
//# sourceMappingURL=multi-view-group.options.js.map